// extracted by mini-css-extract-plugin
module.exports = {"head":"InfoList_head_2RTNJ","category":"InfoList_category_2MgRR","date":"InfoList_date_2B_PF","body":"InfoList_body_2CYqh"};